/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Inbox_OkInputs */

const en_tut_inbox_ok = /** @type {(inputs: Tut_Inbox_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rows you open stop being marked unread, and the counter in the left menu goes down with them.`)
};

const id_tut_inbox_ok = /** @type {(inputs: Tut_Inbox_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baris yang sudah dibuka berhenti ditandai belum dibaca, dan hitungan di menu kiri ikut turun.`)
};

/**
* | output |
* | --- |
* | "Rows you open stop being marked unread, and the counter in the left menu goes down with them." |
*
* @param {Tut_Inbox_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_inbox_ok = /** @type {((inputs?: Tut_Inbox_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Inbox_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_inbox_ok(inputs)
	return en_tut_inbox_ok(inputs)
});